<template>
	<div style="height: 100%; width: 100%;" class="content-pad-vert">
		<div class="nav-container">
			<div class="parallelogramlogo">
				<div class="unskew">
					<div class="d-inline-block">
						<img style="cursor: pointer" @click="saveAndExit" src="/static/images/navbar/logo-color.svg" height="35" alt="WRKPRTY" />
					</div>
					<div class="ml-3 d-inline-block text-xs-center">
						<h4 class="ma-0">Step 1</h4>
						<p>Become a Host</p>
					</div>
				</div>
			</div>
			<div class="parallelogram hidden-xs-only">
				<div class="unskew">
					<div class="text-xs-center" style="color: white!important;">
						<h4 class="ma-0">Step 2</h4>
						<p class="white--text">Location Info</p>
					</div>
				</div>
			</div>
			<div class="parallelogram parallelogram3 hidden-xs-only">
				<div class="unskew">
					<div class="text-xs-center" style="color: white!important;">
						<h4 class="ma-0">Step 3</h4>
						<p class="white--text">Post your wrkprty!</p>
					</div>
				</div>
			</div>
			<div class="d-inline-block pa-3" style="float: right">
				<h4 class="hidden-xs-only">
					<v-btn @click="help" flat small class="pa-1" style="min-width: auto">Help</v-btn>|<v-btn @click="saveAndExit" flat small class="pa-1">Save &amp; Exit</v-btn>
				</h4>
				<v-menu bottom offset-y>
					<v-btn slot="activator" icon>
						<v-icon>
							menu	
						</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile v-for="(item, i) in menuItems" :key="i" @click="item.scr">
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
		</div>
		<v-layout row wrap align-center class="pb-5">
			<v-flex xs12 sm10 md5 offset-sm1 offset-md2 class="pl-3 pr-3 pt-5">
				<p class="add-event-step-secondary-header mb-1">Thanks for your interest in hosting!</p>
				<p class="add-event-step-secondary-header">To get started, please tell us a little more <strong>about you.</strong></p>
				<v-form v-model="valid">
					<v-text-field
						placeholder="Enter your name"
						v-model="name"
						label="Full Name"
						:rules="nameRules"
						required
					></v-text-field>
					<v-text-field
						placeholder="Enter your phone"
						v-model="phone" 
						label="Phone Number"
						:rules="phoneRules"
						mask="phone"
						required
					></v-text-field>
					<div class="text-xs-right" style="font-size: .8em; color: gray; position: relative; top: -22px;">*required so we can contact you.</div>
					<google-maps-autocomplete
						class="mb-2"
						@place_changed="setPlace"
						style="margin-top: -12px;"
						:prefillAddress="address">
					</google-maps-autocomplete>
					<v-checkbox
						color="link"
						v-model="apartmentCheck"
						hide-details
						label="This is an apartment"
					></v-checkbox>
					<v-text-field
						class="mt-2"
						v-if="apartmentCheck"
						placeholder="Enter your apartment/room number"
						:rules="apartmentNumberRules"
						v-model="apartmentNumber"
						label="Apartment or Room Number"
					></v-text-field>
					<p class="mt-4 mb-0 host-apply-content"><span class="add-event-step-secondary-header">About Me</span> (a short bio <strong>for you as a host</strong>)</p>
					<p class="mt-0 mb-0" style="color: #999999">Include qualities people like about you that will come in handy when hosting</p>
					<v-textarea
						v-model="description"
						class="mt-0 pt-1"
						placeholder="Enter your host bio"
						:rules="bioRules"
						hide-details
						required
					></v-textarea>
					<v-btn
						block
						large
						class="btn-blue mt-4 hidden-xs-only"
						@click="gotoNextStep"
						:disabled="!valid || !this.getHostApplyInfo('address') || disableButton"
						:loading="submitting"
					>
						Continue
					</v-btn>
					<p v-if="error" class="red--text">{{error}}</p>
				</v-form>
			</v-flex>
			<v-flex lg3 md4 sm6 hidden-sm-and-down style="padding: 0px 60px 0px 30px;">
				<v-card>
					<v-card-text class="p-relative pt-5">
						<div class="info-trapezoid p-absolute">
							<div class="info-content">
								<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
							</div>
						</div>
						<p class="host-apply-tip-content">Your contact info is used only for us to communicate with you.</p>
						<p class="host-apply-tip-content mb-0">Your phone number and mailing address info <strong>is not</strong> shared with or visible to other users.</p>
						<div style="width: 90%; border-top: 1px solid #888; height: 1px; margin-left: 5%;" class="mt-3 mb-3">
						</div>
						<p class="host-apply-tip-content">Example of About Me (host bio)...</p>
						<p class="host-apply-tip-content2">Hi, I’m Annie. I love human-centered design and the evolving digital space. My expertise is in qualitative research and analysis, service design, product strategy, and IA/UX/UI design executions. Outside of work I enjoy travel, adventure, reading, and surfing. I like meeting people and making sure they feel welcome in new groups... I’m also  famous for my delicious pour-over coffee and I can probably pull off leading a group through 4 really easy yoga poses.</p>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- <v-dialog scrollable v-model="infoDialog">
				<v-card style="width: 100%">
					<v-card-title class="mb-0 pb-2 pt-3">
						<div class="d-block text-xs-center" style="width: 100%;">
							<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
						</div>
					</v-card-title>
					<v-card-text style="height: 50vh;">
						<p class="host-apply-tip-content">Your contact info is used only for us to communicate with you.</p>
						<p class="host-apply-tip-content">Your phone number and mailing address info <strong>is not</strong> shared with or visible to other users.</p>
						<p class="host-apply-tip-content">Example of About Me (host bio)...</p>
						<p class="host-apply-tip-content2">Hi, I’m Annie. I love human-centered design and the evolving digital space. My expertise is in qualitative research and analysis, service design, product strategy, and IA/UX/UI design executions. Outside of work I enjoy travel, adventure, reading, and surfing. I like meeting people and making sure they feel welcome in new groups... I’m also  famous for my delicious pour-over coffee and I can probably pull off leading a group through 4 really easy yoga poses.</p>
					</v-card-text>
					<v-card-actions>
						<v-spacer>
						</v-spacer>
						<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog> -->
			<v-btn small fab bottom right fixed class="btn-yellow add-event-mobile-info-button hidden-md-and-up" v-if="!hostProcessModal" @click="hostProcessModal=true"><img src="/static/images/icon/light-bulb-gray.svg" width="30" /></v-btn>
		</v-layout>
		<v-card v-if="!hostProcessModal" class="add-event-mobile-bottom-nav pa-0 hidden-sm-and-up">
			<v-card-actions class="pa-0">
				<v-btn flat large class="ma-0 add-event-mobile-bottom-nav-back" @click="goBack">Back</v-btn><v-btn flat large :disabled="!valid || !this.getHostApplyInfo('address') || disableButton" class="btn-blue ma-0 add-event-mobile-bottom-nav-next" :loading="submitting" @click="gotoNextStep">Next</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { baseURL } from '~/store/util/values.js'
import GoogleMapsAutocomplete from '~/components/GoogleMapsAutocomplete'
export default {
	data() {
		return {
			submitting: false,
			previousPage: null,
			error: null,
			disableButton: false,
			valid: false,
			nameRules: [
				v => !!v || 'Name is required',
				v => v.split(' ').length > 1 || 'Please enter your full name',
				v => v.length >= 3 || 'Full name must be more than 3 characters'
			],
			bioRules: [
				v => !!v || 'Bio is required'
			],
			phoneRules: [
				v =>
					/(\+?\d{1,2}\s?.?-?)?\(?\d{3}\)?[\s-.]?\d{3}[\s-.]?\d{4}\b/.test(v) ||
					'Please enter a valid phone'
			],
			addressRules: [
				v => !!v || 'Your home address is required',
				v => v !== null && v.length >= 10 || 'Address must be at least 10 characters'
			],
			apartmentNumberRules: [
				v => !!v || 'Your apartment number is required',
				v => v !== null && v.length !== 0 || 'Your apartment number is required',
				v =>
					v !== null && v.length < 20 ||
					'Your apartment number must be less than 20 characters'
			],
			menuItems: [
				{
					title: 'Help',
					scr: this.help
				},
				{
					title: 'Save & Exit',
					scr: this.saveAndExit
				}
			]
		}
	},
	components: {
		GoogleMapsAutocomplete: GoogleMapsAutocomplete
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.submitting = false
			vm.disableButton = false
			vm.previousPage = from
		})
	},
	mounted() {
		this.setlastHostApplyStep(this.$route.name)
		if (!this.getHostApplyInfo('name')) {
			this.setHostApplyInfo({
				prop: 'name',
				value: this.user.first_name + ' ' + this.user.last_name
			})
		}
	},
	methods: {
		...mapActions([
			'setlastHostApplyStep',
			'setHostApplyInfo',
			'serverPostHostApplication',
			'setModalProp',
			'setModalOpen'
		]),
		goBack() {
			if (this.previousPage === null) {
				this.$router.push('/')
			} else {
				this.$router.push(this.previousPage.path)
			}
		},
		help() {
			alert('Help!')
		},
		saveAndExit() {
			this.$router.push({ name: 'dashboard' })
		},
		setPlace(place) {
			this.setHostApplyInfo({
				prop: 'address',
				value: place.formatted_address
			})
			let address = {}
			let components = place.address_components
			for (var i = 0; i < components.length; i++) {
				// JSON Method
				let type = components[i].types[0]
				if (type === 'street_number') {
					address['street_number'] = components[i].long_name
				} else if (type === 'route') {
					address['route'] = components[i].long_name
				} else if (type === 'neighborhood') {
					address['neighborhood'] = components[i].long_name
				} else if (type === 'locality') {
					address['city'] = components[i].long_name
				} else if (type === 'administrative_area_level_2') {
					address['county'] = components[i].long_name
				} else if (type === 'administrative_area_level_1') {
					address['state'] = components[i].long_name
					address['state_short'] = components[i].short_name
				} else if (type === 'country') {
					address['country'] = components[i].long_name
					address['country_short'] = components[i].short_name
				} else if (type === 'postal_code') {
					address['zipcode'] = components[i].long_name
				}
			}
			this.setHostApplyInfo({
				prop: 'newAddress',
				value: address
			})
		},
		gotoNextStep() {
			if (this.valid) {
				this.disableButton = true
				this.submitting = true
				this.serverPostHostApplication().then(response => {
					if (response.hasOwnProperty('response')) {
						// Error
						this.error = response.response.data
                        this.disableButton = false
                        this.submitting = true
						console.log(response.response)
					} else {
						this.applied = true
						this.$router.push('/host/apply/space')
					}
				}).catch(error => {
                    this.disableButton = false
                    this.submitting = true
                })
			}
		}
	},
	computed: {
		...mapGetters(['user', 'getHostApplyInfo', 'getModalProp']),
		name: {
			get() {
				return this.getHostApplyInfo('name')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'name',
					value: val
				})
			}
		},
		phone: {
			get() {
				return this.getHostApplyInfo('phone')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'phone',
					value: val
				})
			}
		},
		address: {
			get() {
				return this.getHostApplyInfo('address')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'address',
					value: val
				})
			}
		},
		description: {
			get() {
				return this.getHostApplyInfo('description')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'description',
					value: val
				})
			}
		},
		hostProcessModal: {
			get() {
				return this.getModalProp('hostProcessModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'hostProcessModal', value: val })
				this.setModalProp({
					prop: 'hostProcessModalPage',
					value: this.$router.currentRoute.name
				})
			}
		},
		apartmentNumber: {
			get() {
				return this.getHostApplyInfo('apartmentNumber')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'apartmentNumber',
					value: val
				})
			}
		},
		apartmentCheck: {
			get() {
				return this.getHostApplyInfo('apartmentCheck')
			},
			set(val) {
				this.setHostApplyInfo({
					prop: 'apartmentCheck',
					value: val
				})
			}
		}
	}
}
</script>

<style lang="scss">
form > .gmapauto {
	background-color: none;
	width: 100%;
	border-bottom: 1px solid #919191;
}
</style>
